import { type AxiosResponse } from 'axios';
import { get, post } from './base.service';

export const verifyLinkApi = (params: {
  key: string;
}): Promise<AxiosResponse> => {
  return get('/verify/link', params);
};

export const checkUserExistApi = (params: {
  search: string;
}): Promise<AxiosResponse> => {
  return get(
    '/check-exist-user',
    params,
    null,
    null,
    import.meta.env['VITE_APP_BASE_PUBLIC_URL']
  );
};

export const verifyCognitoApi = (body: {
  username: string;
  email: string;
  password: string;
  phone_number: string;
}): Promise<AxiosResponse> => {
  return post('/verify/cognito', body);
};

export const verifyEmailApi = (body: {
  username: string;
  confirmation_code: string;
}): Promise<AxiosResponse> => {
  return post('/verify/email', body);
};

export const resentApi = (body: {
  username: string;
}): Promise<AxiosResponse> => {
  return post('/verify/resend', body);
};

export const verifyUserApi = (body: {
  username: string;
  email: string;
  phone_number: string;
  first_name: string;
  last_name: string;
  first_name_yomi: string;
  last_name_yomi: string;
  organization_id: string;
  registered_group: string;
  role: string;
  active: string;
  service_id: string;
  link_id: string;
}): Promise<AxiosResponse> => {
  return post('/verify/user', body);
};
